import { DeviceTesterState } from "../components/device-tester-context-provider/Reducer.types";
import { DeviceStatus } from "../components/results/results-view/ResultsView.types";
import {
  Os,
  Browser,
  HardwareFailure,
  StoreEpicAudioVideoTestResultsMutationVariables,
} from "../graphql/graphql";
import { osNameMap, browserNameMap } from "../types/bowserToEpicMap";

export const epicResultsPayload = (
  deviceTesterState: DeviceTesterState,
  isMobileDevice: boolean,
  sessionId: string | null,
  browser?: string,
  browserVersion?: string,
  os?: string,
  osVersion?: string
): StoreEpicAudioVideoTestResultsMutationVariables => {
  const sesId = sessionId ?? "";

  // If all devices are working then the test was successful
  const success =
    deviceTesterState.cameraResult.status === DeviceStatus.WORKING &&
    deviceTesterState.microphoneResult.status === DeviceStatus.WORKING &&
    deviceTesterState.speakerResult.status === DeviceStatus.WORKING &&
    deviceTesterState.networkResult.status === DeviceStatus.WORKING;
  // Map the browser name to Epic browser name if it exists
  const browserName = browserNameMap.get(browser) ?? Browser.Other;

  // Map the browser name to Epic browser name if it exists
  const osName = osNameMap.get(os) ?? Os.Other;

  const device = isMobileDevice ? "mobile" : "desktop";

  const hardwareFailures = [];
  if (!success) {
    if (deviceTesterState.cameraResult.status !== DeviceStatus.WORKING) {
      hardwareFailures.push(HardwareFailure.Camera);
    }
    if (deviceTesterState.speakerResult.status !== DeviceStatus.WORKING) {
      hardwareFailures.push(HardwareFailure.Speaker);
    }
    if (deviceTesterState.networkResult.status !== DeviceStatus.WORKING) {
      hardwareFailures.push(HardwareFailure.Network);
    }
    if (deviceTesterState.microphoneResult.status !== DeviceStatus.WORKING) {
      hardwareFailures.push(HardwareFailure.Microphone);
    }
  } else {
    hardwareFailures.push(HardwareFailure.Passed);
  }

  return {
    sessionId: sesId,
    success: success,
    browser: browserName,
    browserVersion: browserVersion,
    oS: osName,
    oSVersion: osVersion,
    device: device,
    hardwareFailures: hardwareFailures,
    additionalFailureInfo: "",
  };
};
